import { Currency } from './fields/InputCurrency';
import { Number } from './fields/InputNumber';
import { Percent } from './fields/InputPercent';
import { InputText } from './fields/InputText';
import { Container } from './Container';
import { CurrencyProps, InputProps, NumberProps, PercentProps } from './types';

export const Input = ({ ...props }: Omit<InputProps, 'children'>) => {
  return (
    <Container {...props}>
      <InputText />
    </Container>
  );
};

export const InputCurrency = ({
  text_align = 'right',
  allow_negative = false,
  thousand_separator = true,
  decimal_scale = 2,
  prefix = '$',
  min,
  max,
  ...props
}: Omit<CurrencyProps, 'children'>) => {
  return (
    <Container text_align={text_align} {...props}>
      <Currency
        allow_negative={allow_negative}
        thousand_separator={thousand_separator}
        decimal_scale={decimal_scale}
        prefix={prefix}
        min={min}
        max={max}
      />
    </Container>
  );
};

export const InputNumber = ({
  thousand_separator = true,
  allow_negative = false,
  decimal_scale = 0,
  text_align = 'right',
  min,
  max,
  ...props
}: Omit<NumberProps, 'children'>) => {
  return (
    <Container text_align={text_align} {...props}>
      <Number
        allow_negative={allow_negative}
        thousand_separator={thousand_separator}
        decimal_scale={decimal_scale}
        min={min}
        max={max}
      />
    </Container>
  );
};

export const InputPercent = ({
  thousand_separator = true,
  allow_negative = false,
  decimal_scale = 0,
  text_align = 'right',
  min,
  max,
  ...props
}: Omit<PercentProps, 'children'>) => {
  return (
    <Container text_align={text_align} {...props}>
      <Percent
        allow_negative={allow_negative}
        thousand_separator={thousand_separator}
        decimal_scale={decimal_scale}
        suffix="%"
        min={min}
        max={max}
      />
    </Container>
  );
};
